import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "./RepublishWarningDialog.module.scss";
import BootstrapDialogTitle from "../../components/BootstrapDialogTitle";

interface Props {
  mostRecentTicketNumber?: string;
  open: boolean;
  close: () => void;
}

const RepublishWarningDialog: React.FC<Props> = ({
  mostRecentTicketNumber,
  open,
  close,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog
      className={styles.republishWarningDialog}
      open={open}
      fullWidth
      maxWidth="sm"
    >
      <BootstrapDialogTitle onClose={() => close()}></BootstrapDialogTitle>
      <DialogContent>
        <Alert variant="standard" severity="warning">
          {t("republishMinorChangeWarning", {
            ticketNumber: mostRecentTicketNumber,
          })}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button
          className={styles.no}
          variant="text"
          onClick={() => close()}
        >
          {t("close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RepublishWarningDialog;
